const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M11 0C4.92525 0 0 4.92525 0 11C0 17.0748 4.92525 22 11 22C17.0748 22 22 17.0748 22 11C22 4.92525 17.0748 0 11 0ZM14.8051 16.4478L11.0073 12.6876L7.23342 16.5L5.55317 14.8197L9.31517 11.0092L5.5 7.23342L7.18025 5.55317L10.989 9.31333L14.7528 5.5L16.4478 7.19492L12.6894 10.9908L16.5 14.7528L14.8051 16.4478Z"
      />
    </svg>
  );
};
